var AuthState;
(function(AuthState) {
    AuthState["Uninitialized"] = 'uninitialized';
    AuthState["Initialized"] = 'initialized';
    AuthState["LoggedIn"] = 'logged-in';
    AuthState["LoggedOut"] = 'logged-out';
    AuthState["ParseHashFailed"] = 'parse-hash-failed';
})(AuthState || (AuthState = {}));
function getLoggedInState(auth) {
    if (!auth || isUninitialized(auth) || isInitialized(auth)) {
        return 'loading';
    }
    if (isLoggedIn(auth)) {
        return AuthState.LoggedIn;
    }
    return AuthState.LoggedOut;
}
const isState = (stateName)=>(state)=>state.state === stateName
;
const isUninitialized = isState(AuthState.Uninitialized);
const isInitialized = isState(AuthState.Initialized);
const isLoggedInPasswordless = (state)=>state.state === AuthState.LoggedIn && state.type === 'passwordless'
;
const isLoggedIn = (state)=>state.state === AuthState.LoggedIn && state.type === 'regular'
;
const isParseHashFailed = isState(AuthState.ParseHashFailed);
const isLoggedOut = isState(AuthState.LoggedOut);

export { AuthState, getLoggedInState, isInitialized, isLoggedIn, isLoggedInPasswordless, isLoggedOut, isParseHashFailed, isUninitialized };
//# sourceMappingURL=state.js.map
